module.exports = __webpack_public_path__ + "static/media/trips_logo.ff9aebeb.svg";